var chunkToChildrenMap = {
	"5543": [
		2483
	],
	"5564": [
		2483,
		5543
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));